import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { petoskeyConfig } from "./data";

export default function PetoskeyPage() {
  return <CityPageTemplate config={petoskeyConfig} />;
}